import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialIntegrationState = {
  detailsStatus: STATUS.IDLE,
  splunkSettings: [],
  slackSettings: [],
  mTeamsSettings: [],
  browserlingToken: '',
  browserlingStatus: STATUS.IDLE,
};

export default (state = initialIntegrationState, action) => {
  switch (action?.type) {
    case types.LOAD_SPLUNK:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_SPLUNK): {
      const splunkIntegrationsWithType = [...action?.payload?.results]?.map(
        (integration) => {
          integration.type = 'Splunk Integration';
          return integration;
        },
      );

      return {
        ...state,
        splunkSettings: splunkIntegrationsWithType,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SPLUNK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.UPDATE_SPLUNK: {
      const integration = action?.data;

      const index = state?.splunkSettings?.findIndex(
        (p) => p?.uuid === integration?.uuid,
      );
      if (index < 0) return state;
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
        splunkSettings: [
          ...state?.splunkSettings?.slice(0, index),
          { ...integration },
          ...state?.splunkSettings?.slice(index + 1),
        ],
      };
    }

    case resolve(types.UPDATE_SPLUNK): {
      // const integration = action.data;
      //console.log('i', integration);

      return {
        ...state,
        // splunkSettings: action.payload.results,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_SPLUNK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };
    case types.SAVE_SPLUNK: {
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.SAVE_SPLUNK): {
      const newSplunkIntegration = {
        ...action?.payload,
        type: 'Splunk Integration',
      };

      return {
        ...state,
        splunkSettings: [...state?.splunkSettings, newSplunkIntegration],
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.SAVE_SPLUNK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.DELETE_SPLUNK: {
      const index = state?.splunkSettings?.findIndex(
        (p) => p?.uuid === action?.uuid,
      );

      return {
        ...state,
        splunkSettings: [
          ...state?.splunkSettings?.slice(0, index),
          ...state?.splunkSettings?.slice(index + 1),
        ],
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.DELETE_SPLUNK): {
      return {
        ...state,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.DELETE_SPLUNK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_SLACK:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_SLACK): {
      const slackIntegrationsWithType = [...action?.payload?.results]?.map(
        (integration) => {
          integration.type = 'Slack Integration';
          return integration;
        },
      );

      return {
        ...state,
        slackSettings: slackIntegrationsWithType,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_SLACK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.UPDATE_SLACK: {
      const integration = action?.data;

      const index = state?.slackSettings?.findIndex(
        (p) => p?.uuid === integration?.uuid,
      );
      if (index < 0) return state;
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
        slackSettings: [
          ...state?.slackSettings?.slice(0, index),
          { ...integration },
          ...state?.slackSettings?.slice(index + 1),
        ],
      };
    }

    case resolve(types.UPDATE_SLACK): {
      return {
        ...state,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_SLACK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.SAVE_SLACK: {
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.SAVE_SLACK): {
      const newSlackIntegration = {
        ...action?.payload,
        type: 'Slack Integration',
      };

      return {
        ...state,
        slackSettings: [...state?.slackSettings, newSlackIntegration],
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.SAVE_SLACK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.DELETE_SLACK: {
      const index = state?.slackSettings?.findIndex(
        (p) => p?.uuid === action?.uuid,
      );

      return {
        ...state,
        slackSettings: [
          ...state?.slackSettings?.slice(0, index),
          ...state?.slackSettings?.slice(index + 1),
        ],
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.DELETE_SLACK): {
      return {
        ...state,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.DELETE_SLACK):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.LOAD_M_TEAMS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_M_TEAMS): {
      const mTeamsIntegrationsWithType = [...action?.payload?.results]?.map(
        (integration) => {
          integration.type = 'Microsoft Teams Integration';
          return integration;
        },
      );

      return {
        ...state,
        mTeamsSettings: mTeamsIntegrationsWithType,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_M_TEAMS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.UPDATE_M_TEAMS: {
      const integration = action?.data;

      const index = state.mTeamsSettings?.findIndex(
        (p) => p?.uuid === integration?.uuid,
      );
      if (index < 0) return state;
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
        mTeamsSettings: [
          ...state?.mTeamsSettings?.slice(0, index),
          { ...integration },
          ...state?.mTeamsSettings?.slice(index + 1),
        ],
      };
    }

    case resolve(types.UPDATE_M_TEAMS): {
      return {
        ...state,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_M_TEAMS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.SAVE_M_TEAMS: {
      return {
        ...state,
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.SAVE_M_TEAMS): {
      const newMTeamsIntegration = {
        ...action?.payload,
        type: 'Microsoft Teams Integration',
      };

      return {
        ...state,
        mTeamsSettings: [...state?.mTeamsSettings, newMTeamsIntegration],
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.SAVE_M_TEAMS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.DELETE_M_TEAMS: {
      const index = state?.mTeamsSettings?.findIndex(
        (p) => p?.uuid === action?.uuid,
      );

      return {
        ...state,
        mTeamsSettings: [
          ...state.mTeamsSettings?.slice(0, index),
          ...state.mTeamsSettings?.slice(index + 1),
        ],
        detailsStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.DELETE_M_TEAMS): {
      return {
        ...state,
        detailsStatus: STATUS.LOADED,
      };
    }
    case reject(types.DELETE_M_TEAMS):
      return {
        ...state,
        error: true,
        detailsStatus: STATUS.ERROR,
      };

    case types.GET_ACCESS_TOKEN_BROWSERLING:
      return {
        ...state,
        browserlingStatus: STATUS.LOADING,
      };
    case resolve(types.GET_ACCESS_TOKEN_BROWSERLING):
      return {
        ...state,
        browserlingToken: action?.payload?.token,
        browserlingStatus: STATUS.LOADED,
      };

    default:
      return state;
  }
};
